module.exports = __webpack_public_path__ + "static/media/video.448c7a88.png";